"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenArrays = exports.itemExists = exports.sortArrayOfObjects = exports.filterEmpty = exports.sortAlpha = exports.addDistinct = void 0;
const object_helpers_1 = require("./object.helpers");
const addDistinct = (arr = [], item, predicate) => {
    if (!arr.find((arrayItem) => predicate(arrayItem))) {
        arr.push(item);
    }
    return arr;
};
exports.addDistinct = addDistinct;
const sortAlpha = (arr, dataPath) => arr.sort((a, b) => (0, object_helpers_1.getAtPath)(a, dataPath) > (0, object_helpers_1.getAtPath)(b, dataPath) ? 1 : -1);
exports.sortAlpha = sortAlpha;
const filterEmpty = (arr, dataPath) => arr.filter((v) => !(0, object_helpers_1.getAtPath)(v, dataPath));
exports.filterEmpty = filterEmpty;
function sortArrayOfObjects(data, property, asc = true) {
    data.sort((a, b) => a[property] - b[property]);
    if (!asc) {
        data.reverse();
    }
    return data;
}
exports.sortArrayOfObjects = sortArrayOfObjects;
/**
 * Returns true if the given array contains an item that matches
 * the value at the given key if it's an object, or just the value
 * if it's a primitive.
 * @param items
 * @param key
 * @param value
 */
function itemExists(items, value, key) {
    return (items.find((item) => typeof item === 'object'
        ? (0, object_helpers_1.getAtPath)(item, key) === value
        : item === value) !== undefined);
}
exports.itemExists = itemExists;
/**
 * Flattens an array of arrays by a given key.
 * @param arrays
 * @param flattenKey
 */
function flattenArrays(arrays, flattenKey) {
    return arrays.reduce((flattened, current) => {
        return [...flattened, ...current[flattenKey]];
    }, []);
}
exports.flattenArrays = flattenArrays;
